import React from 'react'
import { STEPS } from './constants'

import { SuccsessIcon } from './icons/SuccsessIcon'
import { ErrorIcon } from './icons/ErrorIcon'

const getTitle = ({ isSuccess, isError }) => {
  if (isSuccess) {
    return 'Your missions were generated'
  } else if (isError) {
    return 'It was not possible to generate your missions'
  } else {
    return 'Generate Missions'
  }
}

const getTitleComponent = ({ classes, currentStep }) => {
  const isSuccess = STEPS.SUCCESS === currentStep
  const isError = STEPS.ERROR === currentStep
  const title = getTitle({ isSuccess, isError })

  return (
    <div
      style={{ marginBottom: currentStep === STEPS.SECOND ? 14 : 32 }}
      className={classes.title}
    >
      {isSuccess ? <SuccsessIcon /> : null}
      {isError ? <ErrorIcon /> : null}
      {title}
    </div>
  )
}

const formatLocations = postcodes => {
  return postcodes.reduce((acc, item) => {
    acc.push(...item.locations)
    return acc
  }, [])
}

const toLocalISODate = date =>
  new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .split('T')[0]

const getMissionTimeByType = ({ city, type }) => {
  const { morningCheckInTime, lunchCheckInTime, afternoonCheckInTime } = city
  if (type === 0) {
    return morningCheckInTime
  } else if (type === 1) {
    return lunchCheckInTime
  } else if (type === 2) {
    return afternoonCheckInTime
  }
}

const splitMissionsByChunksForTLA = (missionsToGenerate, chunkSize = 20) => {
  const chunks = []
  const groupedMissions = {}

  // Group missions by locationId and dateTime
  missionsToGenerate.forEach(mission => {
    const key = `${mission.locationId}_${mission.dateTime}`
    if (!groupedMissions[key]) {
      groupedMissions[key] = []
    }
    groupedMissions[key].push(mission)
  })

  // Create initial chunks from grouped missions
  const initialChunks = []
  Object.values(groupedMissions).forEach(group => {
    initialChunks.push(group)
  })

  // Merge small chunks
  let currentChunk = []
  for (const chunk of initialChunks) {
    // If current chunk + new chunk doesn't exceed the limit, merge them
    if (currentChunk.length + chunk.length <= chunkSize) {
      currentChunk = [...currentChunk, ...chunk]
    } else {
      // If current chunk is not empty, add it to the result
      if (currentChunk.length > 0) {
        chunks.push(currentChunk)
      }
      // Add new chunk as is, without splitting it
      currentChunk = [...chunk]
    }
  }

  // Add the last chunk if it's not empty
  if (currentChunk.length > 0) {
    chunks.push(currentChunk)
  }

  return chunks
}

export {
  getTitleComponent,
  formatLocations,
  toLocalISODate,
  getMissionTimeByType,
  splitMissionsByChunksForTLA,
}
